import React from "react";
import {useTranslation} from "react-i18next";
import Dates from "utils/Dates";
import {LOCALE} from "helpers/config";
import {useTypedSelector} from "helpers/reducers";

const BookingDateHeaderNamed = (props: {date: any}) => {
    const {t} = useTranslation();
    const selectedTimeslot = useTypedSelector(state => state.bookingState.bookingProcess.selectedTimeslot);
    const sessionLangauge = useTypedSelector(state => state.sessionState.language);

    return (
        <div className={"BookingDateHeaderNamed font-medium text-lg md:text-xl gap-2 flex"}>
            <span>
                {Dates.intlDateFormat(
                    new Date(props.date).getTime(),
                    {weekday: "short", day: "2-digit", month: "2-digit"},
                    sessionLangauge ? sessionLangauge.locale : LOCALE
                )}
            </span>
            {selectedTimeslot && <span>{Dates.time(selectedTimeslot.start_at)}</span>}
        </div>
    );
};

export default BookingDateHeaderNamed;
